import { motion } from "framer-motion";

export default function IndustryCard({ industry, index = 0 }) {
  const Icon = industry.icon;
  return (
    <motion.div
      data-testid={`industry-card-${industry.slug}`}
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      className="group bg-white border border-slate-200 rounded-md p-6 md:p-7 card-hover"
    >
      <div className="w-10 h-10 bg-blue-50 text-[#1E40AF] rounded-sm flex items-center justify-center group-hover:bg-[#1E40AF] group-hover:text-white transition-colors">
        <Icon className="w-5 h-5" />
      </div>
      <h3 className="font-display text-lg md:text-xl text-[#0A1F44] mt-5 tracking-tight">
        {industry.title}
      </h3>
      <p className="text-sm text-slate-600 mt-2 leading-relaxed">{industry.blurb}</p>
    </motion.div>
  );
}
